// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__11PTu","productName":"Table_productName__a-k35"};